<template>
    <div class="relative">
        <search-icon class="search-icon absolute ml-2 text-grey-dark"></search-icon>
        <cancel-icon v-if="value"
            class="absolute right-0 mr-2 mt-2 cursor-pointer text-gray-500 hover:text-gray-600"
            title="Clear"
            @click.native="clear"></cancel-icon>
        <input type="text"
            placeholder="Search"
            :value="value"
            v-focus="focus"
            @input="$emit('input', $event.target.value)"
            class="w-full pl-10 pr-10 py-2 bg-transparent"
            :class="customClass" />
    </div>
</template>
<script>
    export default {
        props: {
            value: null,
            customClass: {
                type: String,
                default: ''
            },
            focus: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            SearchIcon: () =>
                import ( /*webpackChunkName: "search-icon"*/ '@/icons/Search.vue')
        },
        methods: {
            clear() {
                this.$emit('input', '')
                this.$emit('cleared')
            }
        }
    }
</script>
<style lang="scss"
    scoped>
    .search-icon {
        margin-top: 10px;
    }
</style>